import { render, staticRenderFns } from "./parentVariant.vue?vue&type=template&id=67b79811"
import script from "./parentVariant.vue?vue&type=script&lang=js"
export * from "./parentVariant.vue?vue&type=script&lang=js"
import style0 from "./parentVariant.vue?vue&type=style&index=0&id=67b79811&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports